import React, { useEffect, useRef, useState } from 'react'
import { agentColors } from './agentChatLayout'

/**
 * ⋯ menu for thread rename / delete.
 */
export default function AgentThreadMenu({ onRename, onDelete, onClose }) {
  const ref = useRef(null)

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose()
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [onClose])

  return (
    <div
      ref={ref}
      style={{
        position: 'absolute',
        right: 0,
        top: '100%',
        marginTop: 4,
        minWidth: 120,
        background: agentColors.bgCard,
        border: `1px solid ${agentColors.borderSoft}`,
        borderRadius: 8,
        boxShadow: '0 8px 24px rgba(28, 25, 23, 0.12)',
        zIndex: 30,
        overflow: 'hidden',
      }}
    >
      <button
        type="button"
        onClick={() => {
          onRename()
          onClose()
        }}
        style={menuBtnStyle}
      >
        Rename
      </button>
      <button
        type="button"
        onClick={() => {
          onDelete()
          onClose()
        }}
        style={{ ...menuBtnStyle, color: agentColors.danger }}
      >
        Delete
      </button>
    </div>
  )
}

const menuBtnStyle = {
  display: 'block',
  width: '100%',
  textAlign: 'left',
  padding: '10px 14px',
  border: 'none',
  background: 'transparent',
  fontSize: 13,
  cursor: 'pointer',
  color: agentColors.textPrimary,
}
